module.exports = __webpack_public_path__ + "media/app/assets/imgs/exchange/follow_confirmed-1e32bae8691a3d38a6eb9279e7d2ef25.png";